import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import {
	ClaimGift,
	CollectionsGroup,
	Sticker,
	StickerCollection,
} from '@/core/interfaces';

interface CollectionsState {
	collections: CollectionsGroup[];
	stickerWon: ClaimGift | null;
	showStickerWonDialog: boolean;
	activeCollectionPosition: number | null;
	activeCollection: StickerCollection | null;
	activeCollectionGroup: CollectionsGroup | null;
}

const collectionsSlice = createSlice({
	name: 'collections',
	initialState: {
		collections: [],
		stickerWon: null,
		showStickerWonDialog: false,
		activeCollectionPosition: null,
		activeCollectionGroup: null,
		activeCollection: null,
	} as CollectionsState,
	reducers: {
		setCollections: (state, action: PayloadAction<CollectionsGroup[]>) => {
			// console.log(action);
			// debugger;
			state.collections = action.payload;
		},
		setWonSticker: (state, action: PayloadAction<ClaimGift | null>) => {
			state.stickerWon = action.payload;
		},
		setStickerWonDialog: (state, action: PayloadAction<boolean>) => {
			state.showStickerWonDialog = action.payload;
		},
		setActiveCollectionGroup: (
			state,
			action: PayloadAction<string | null>
		) => {
			// console.log('active group', action.payload);
			const group = state.collections.find(
				(group) => group.id === action.payload
			);
			state.activeCollectionGroup = group || null;
		},
		setActiveCollection: (
			state,
			action: PayloadAction<{ groupId: string; collectionId: string }>
		) => {
			const { groupId, collectionId } = action.payload;
			console.log('active collection', groupId, collectionId);

			// Find the group by name
			const groupIndex = state.collections.findIndex(
				(collectionGroup) => collectionGroup.id === groupId
			);
			if (groupIndex === -1) {
				console.error('Group not found:', groupId);
				return;
			}

			const collectionGroup = state.collections.find(
				(collectionGroup) => collectionGroup.id === groupId
			);
			if (!collectionGroup) {
				console.error('Collection group not found:', groupId);
				return;
			}

			// Find the collection inside the group
			const collection = state.collections[groupIndex].items.find(
				(item) => item.id === collectionId
			);
			if (!collection) {
				console.error('Collection not found:', collectionId);
				return;
			}

			// Set the active collection and active group correctly
			state.activeCollectionGroup = { ...collectionGroup };
			state.activeCollection = { ...collection }; // Spread the object to create a non-proxy object
			state.activeCollectionPosition = state.collections[
				groupIndex
			].items.findIndex((item) => item.id === collectionId);

			// Log for debugging
			console.log('State after setting active collection:', {
				activeCollectionGroup: state.activeCollectionGroup,
				activeCollection: state.activeCollection,
			});
		},
		updateCollection: (
			state,
			action: PayloadAction<{ collectionID: string; sticker: Sticker }>
		) => {
			const { collectionID, sticker } = action.payload;

			for (const group of state.collections) {
				const collection = group.items.find(
					(collection) => collection.id === collectionID
				);

				// If the collection is found, update the sticker
				if (collection) {
					// Find the sticker inside the collection by sticker position
					const stickerIndex = collection.stickers.findIndex(
						(s) => s.position === sticker.position
					);

					// If the sticker is found, update it
					if (stickerIndex !== -1) {
						collection.stickers[stickerIndex] = sticker;

						// Increment the number of stickers collected (optional)
						collection.numStickersCollected++;
					}

					// Exit the loop since the collection was found and updated
					break;
				}
			}
		},
		setCompleteCollection: (
			state,
			action: PayloadAction<{ collectionID: string }>
		) => {
			const { collectionID } = action.payload;

			for (const group of state.collections) {
				const collection = group.items.find(
					(collection) => collection.id === collectionID
				);

				if (collection) {
					collection.completed = true;
				}

				break;
			}
		},
	},
});

const { reducer, actions } = collectionsSlice;

export const {
	setCollections,
	setWonSticker,
	setStickerWonDialog,
	updateCollection,
	setActiveCollectionGroup,
	setActiveCollection,
	setCompleteCollection,
} = actions;
export default reducer;
